import { type ReactNode } from "react";

interface VehicleValuationActionGroupProps {
  children: ReactNode;
  title: string;
}

export function VehicleValuationActionGroup({ children, title }: VehicleValuationActionGroupProps) {
  return (
    <section className="space-y-2">
      <h3 className="text-muted-foreground text-xs font-semibold tracking-wide uppercase">{title}</h3>
      <div className="grid grid-cols-[repeat(auto-fit,minmax(min(100%,13rem),1fr))] gap-2 [&_button]:h-auto [&_button]:min-h-9 [&_button]:w-full [&_button]:justify-start [&_button]:py-2 [&_button]:text-left [&_button]:whitespace-normal">
        {children}
      </div>
    </section>
  );
}
